import { Component, Input } from '@angular/core';

/**
 * Displays name for a connection type
 */
@Component({
  selector: 'app-connection-type-name',
  template: `
  <span class="capitalize">
  {{ connectionType?.entityType1?.namePlural}}
  <i class="fal fa-plus"></i>
  {{ connectionType?.entityType2?.namePlural}}
</span>

    `
})
export class ConnectionTypeNameComponent {
  @Input() connectionType: { entityType1: { namePlural: string }; entityType2: { namePlural: string } };
}
